export default __webpack_public_path__ + "./assets/product-card-model2__fbe5e11bfeb8d22f7c64de37627799b5.png";